import React, { useEffect } from "react";
import { Button, Form } from "antd";
import get from "lodash/get"
import TemplateMetaForm from "./templateMetaForm";

const TemplateMetaValue = ({
  onSubmitFormValue,
  goToStep,
  initialValues,
  templateType,
}) => {
  const [form] = Form.useForm();
  useEffect(()=> {
    if(templateType===3){
      form.setFieldValue(['default_values','press_cycle'], get(initialValues,"press_cycle",1))
    }
    },[initialValues])
  return (
    <div className="mt-10">
      <Form
        onFinish={(values) => {
          onSubmitFormValue(values, 3);
        }}
        autoComplete="off"
        form={form}
        layout="vertical"
        requiredMark={false}
        initialValues={{ default_values: initialValues }}
      >
        <TemplateMetaForm templateType={templateType} form={form} initialValues={{ default_values: initialValues }} />
      </Form>

      <div className="w-full bg-white p-4">
        <div className="flex justify-end space-x-2">
          <Button
            onClick={() => {
              goToStep(1);
            }}
            className="border-gray-300"
          >
            Back
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TemplateMetaValue;
